import { spawn } from 'redux-saga/effects';

import companyLookup from './companyLookup';
import localStorage from './localStorage';
import prefillForm from './prefillForm';
import steps from './steps';

export default function* signupSaga() {
  yield spawn(companyLookup);
  yield spawn(localStorage);
  yield spawn(steps);
  yield spawn(prefillForm);
}
